var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15C11.4477 15 11 14.5522 11 14V9.99996C11 9.44768 11.4477 8.99996 12 8.99996C12.5523 8.99996 13 9.44767 13 9.99996V14C13 14.5522 12.5523 15 12 15Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6842 3.65886C13.5788 1.44705 10.4226 1.44704 9.31716 3.65886L2.32033 17.6591C1.32347 19.6538 2.77397 22.0002 5.00387 22.0002H18.9975C21.2274 22.0002 22.6779 19.6538 21.6811 17.6591L14.6842 3.65886ZM11.1062 4.55295C11.4746 3.81568 12.5267 3.81568 12.8952 4.55295L19.892 18.5532C20.2243 19.2181 19.7408 20.0002 18.9975 20.0002H5.00387C4.26057 20.0002 3.77707 19.2181 4.10936 18.5532L11.1062 4.55295Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.4eb193d5.svg";
export { ForwardRef as ReactComponent };